import React from "react";
import MPChips from "../../MPFactory/MPChips";
import { useTranslation } from "react-i18next";
const MarkConversationUninterested = ({
  saveConversationPreferences,
  conversationPref,
}) => {
  const { t } = useTranslation();
  
  const onUnInterested = () => {
    const isUnInterested = conversationPref?.isInterested === false ? null : false;  
    const prefs = {
      isInterested: isUnInterested,
      reminderDuration: conversationPref?.reminderDuration,
    };
    saveConversationPreferences(prefs);
  };
  return (
    <div style={styles.wrapper}>
      <MPChips
        onChipClick={onUnInterested}
        selected={conversationPref && conversationPref?.isInterested === false}
        text={t("NOT_INTERESTED")}
      />
    </div>
  );
};
const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    marginTop: "-8px",
    marginRight: "5px",
  },
};
export default MarkConversationUninterested;
